import {
	Route,
	RouterProvider,
	Routes as RouterDomRoutes,
	createBrowserRouter,
	createRoutesFromElements,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { SharedModals } from '@app/modals'
import { WebSocketProvider } from '@shared/context/WebSocketProvider'
import { useChatSocket } from '@entities/messanger'
import { StudentRouterGroup } from './dashboard/student-router-group';
import { TeacherRouterGroup } from './dashboard/teacher-router-group';
import { Loader } from '@shared/ui/loader/loader';
import { AuthRouterGroup } from './auth/auth-router-group';
import { ConfirmPhone } from "pages/auth/confirm-phone-page";
import { VerifyPage } from '@pages/auth/verify-page';
import { NotFound } from '@pages/not-found/index';
import { useProfile } from "@shared/api/useProfile";
import { useMaintenance } from "@shared/api/useMaintenance";
import { Maintenance } from "@pages/maintenance";
import { useTheme } from '@shared/context/ThemeContext';
import { ErrorBoundary, RouterErrorPage } from '@shared/ui/error-boundary';


export function Routes() {
	const {data: profile, isSuccess: profileSuccess, isError} = useProfile()
	const {data: maintenance, isSuccess: maintenanceSuccess, isError: maintenanceIsError} = useMaintenance()

  	const hasJWT = () => !!localStorage.getItem("token")

	if(isError){
		localStorage.removeItem('token')
		window.location.reload();
	}

	if((maintenance?.maintenance && maintenanceSuccess) || maintenanceIsError){
		return <Maintenance/>
	}

  return (
      <RouterDomRoutes>
        {hasJWT() ?
				<>
					{profileSuccess ? (
						profile?.phone_verified_at ?
						<>
								{
									{
										student: <Route path="*" element={<StudentRouterGroup/>} />,
										teacher: <Route path="*" element={<TeacherRouterGroup/>} />,
									}[profile?.role]
								}
						</> :
						<>
							<Route path="/" element={<ConfirmPhone/>}/>
							<Route path="/verify-email/:token" element={<VerifyPage />} />
							<Route path="*" element={<NotFound />}/>
						</>
					) : (
						<Route path="*" element={<div style={{height: '100svh', width: '100vw'}}><Loader/></div>}/>
					)}
				</> : 
				<Route path="*" element={<AuthRouterGroup/>} />
       }
        <Route path="*" element={<NotFound />}/>
      </RouterDomRoutes>
  );
}

const ChatSocketInitializer = () => {
	useChatSocket();

	return null;
}

// Всё, что раньше жило внутри <BrowserRouter>, переносим в корневой роут data router
const RootRoute = () => {
	const { resolvedTheme } = useTheme();

	return (
	<WebSocketProvider>
		<ChatSocketInitializer />
		<ErrorBoundary>
			<Routes />
		</ErrorBoundary>
		<SharedModals/>
		<ToastContainer
			theme={resolvedTheme}
			hideProgressBar={true}
			newestOnTop={false}
			closeOnClick
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover/>
	</WebSocketProvider>
	);
};

const router = createBrowserRouter(
	createRoutesFromElements(<Route path="/*" element={<RootRoute/>} errorElement={<RouterErrorPage/>}/>)
);

export const AppRouter = () => <RouterProvider router={router}/>;
